module.exports = __webpack_public_path__ + "static/media/navbarAlert.3b27294f.svg";